<template>
  <div>
    <BackButton v-if="isBackButtonShown" class="mb-3" />

    <WaveSpinner v-if="!order"/>
    <!-- <article> is used because an <address> semantically refers to containing <article> -->
    <article v-else class="order" :key="order.id">
      <b-row class="order-header">
        <b-col lg="5" sm="7">
          <div>Order # <b>{{order.number}}</b></div>
          <div class="long">Email <b :title="order.guest_email">{{order.guest_email}}</b></div>
          <div v-if="order.date_shipped">Date Shipped <b>{{order.date_shipped.substring(0,10)}}</b></div>
          <div v-else>Date Placed <b>{{order.date_placed.substring(0,10)}}</b></div>
          <div>Total <b>${{order.total_incl_tax.toFixed(2)}}</b></div>
        </b-col>
        <b-col lg="4" sm="5">
          <dl>
            <dt>
                Ship To
                <AddressVerification
                  :address="order.shipping_address"
                  :on-verification-finish="onAddressVerificationFinish"
                  address-type="shipping"
                />
            </dt>
            <dd><Address :value="order.shipping_address"/></dd>

            <slot name="shipping" :order="order"></slot>
          </dl>
        </b-col>
        <b-col lg="3" sm="12" class="order-actions text-center text-lg-left">
          <b-button
            v-if="showReviewButton(order)"
            :to="reviewPagePath(order)"
            variant="default"
            class="d-lg-block mb-lg-3">Review</b-button>
          <b-button
            v-if="showTrackButton(order)"
            @click="trackOrder(order)"
            variant="default"
            class="d-lg-block mb-lg-3">Track</b-button>
          <b-button
            v-if="showReorderButton(order)"
            @click="onReOrder(order.id)"
            :disabled="showReorderButtonSpinner(order.id)"
            variant="primary"
            class="d-lg-block mb-lg-3">
              <WaveSpinner v-if="showReorderButtonSpinner(order.id)" inline />
              <span v-else>Re-order</span>
          </b-button>
          <slot name="actions" :order="order"></slot>

          <!--
          <button size="sm" @click="trackOrder" class="btn btn-default d-lg-block mb-lg-3">Track</button>
          <button size="sm" @click="reOrder" class="btn btn-primary d-lg-block">Re-order</button>
          -->
        </b-col>
      </b-row>
      <b-row class="order-line" v-for="line in order.lines" :key="line.url">
        <b-col>
          <LineItemThumbnails :preview_urls="line.preview_urls" popover />
        </b-col>
        <b-col>
          <b>Qty:</b> {{ +line.quantity * +line.boxSize }}
          <div><slot name="line-actions" :order="order" :line="line"/></div>
        </b-col>
        <b-col class="productTitle" sm="12">
          {{ line.productTitle || (line.product ? line.product.title : '(product information is loading)') }}
          <hr>
        </b-col>
      </b-row>
    </article>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import orderStatus from '@/lib/orderStatus';

  export default {
    props: {
      order: { type: Object, required: false },
      isBackButtonShown: { type: Boolean, default: true },
    },
    data() {
      return {
        reOrderId: null, // `id` of order for re-order action (used to show spinner).
      }
    },
    computed: {
      ...mapGetters(['flags', 'user']),
      isStaffDashboard() {
        return this.$route.path.startsWith('/admin');
      }
    },
    methods: {
      ...mapActions(['reOrder', 'updateRecentOrders']),
      status(order) {
        return orderStatus(order.status);
      },
      trackOrder(order) {
        // Open new window with direct URL for UPS
        // order.tracking_number may have commas. UPS page works if we separate with \r\n
        let tracknum = order.tracking_number.replace(',', '\r\n');
        let url = `https://www.ups.com/track?loc=en_US&tracknum=${encodeURIComponent(tracknum)}&requester=WT/trackdetails`;
        window.open(url, 'track');
      },
      showTrackButton(order) {
        return this.status(order) === 'shipped' && order.tracking_number;
      },
      onReOrder(orderId) {
        this.reOrderId = orderId;
        this.reOrder(orderId).then(() => {
          this.reOrderId = null;
        });
      },
      showReorderButton(order) {
        // Hide re-order button in "admin" dashboard.
        return !this.isStaffDashboard && this.flags.showUnimplementedOrderActions && !this.showReviewButton(order);
      },
      showReorderButtonSpinner(orderId) {
        return this.reOrderId === orderId;
      },
      showReviewButton(order) {
        return this.user.user_type === 'admin' && this.status(order) === 'review';
      },
      onAddressVerificationFinish() {
        this.updateRecentOrders();
      },
      reviewPagePath(order) {
        if (this.isStaffDashboard) {
          return `/admin/orders/${order.id}`
        }
        return `/dashboard/orders/${order.id}`
      },
    },
  };
</script>

<style scoped lang="scss">
  @import '~scss/abstracts/_variables.scss';
  @import '~scss/colors.scss';

  .long {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .order-header {
    border: 1px solid $grey;
    color: $light-charcoal;
    background-color: $light-grey;
    border-radius: 0.25rem;
    padding: 1em;
    margin-bottom: 1em;
  }
  .order-line {
    margin-left: -35px;
  }
  .productTitle {
    margin-left: 4px;
  }
  .order-line:last-child hr {
    height: 1px;
    background-color: $red;
    border: none;
    width: 101.4%;
  }
  .status {
    text-align: right;
    font-size: smaller;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    font-weight: bold;
    color: $gray-0;
    padding-bottom: 1em;
  }
</style>

<style>
  address {
    font-size: smaller;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/orders/OrderDetailCommon.vue